import { ActionCompletedActivity } from 'store/modules/activities'
import { ActivityItemVm } from './activity-item-vm'

export class ActionActivityItemVm extends ActivityItemVm<ActionCompletedActivity> {
  get content() {
    return this.activity.record.content
  }

  get recordId() {
    return parseInt(this.activity.record.id)
  }

  get skills() {
    return [
      ...this.activity.record.skills,
      ...this.activity.record.profileSkills.map((ps) => ({
        id: ps.id,
        name: ps.name,
        slug: null,
      })),
    ]
  }

  get title() {
    return 'Completed Action'
  }
}
